<template>
   <div class="container">
      <section class="multi_product_wrap">
           <span class="back_arrow" @click="go_back()"><i class="fas fa-angle-double-left"></i> {{get_local_string.string_86}}</span>
       <form  @submit.prevent="sub()" >
        <b-steps
            :position="position"
            :label-position="labelPosition"
            :size="size"
            :isAnimated="true"
            type="is-success"
            @input="get_step_active()"
            v-model="active_step" 
            >
            <!-- vertical -->
            <b-step-item value="1" label="Pizza" icon="silverware-fork-knife">
                    <h2 class="title_step">{{get_local_string.string_91}} {{max_pizza}} </h2>
                <div class="row">
                    <template v-for="tilbud_box in get_box_details.multiFoodList">
                           <div v-for="(item_box) in tilbud_box.data" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mb-5"  :key="item_box.id">
                          <b-checkbox :disabled="tilbue_pizza_selected.length >= max_pizza && tilbue_pizza_selected.indexOf(item_box) == -1"  v-model="tilbue_pizza_selected" type="is-success"
                            :native-value="item_box" @input="on_select_pizza()">
                             <div class="box_tilbud">
                            <template v-if="item_box.image">
                                <img :src="item_box.image" :alt="item_box.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>
                            <p>{{item_box.name}}</p>
                        </div>
                        </b-checkbox>
                       
                    </div>
                    </template>
                </div>
            </b-step-item>
            <b-step-item value="2" :visible="showEntress_step"  label="Entress" icon="delete-variant">
                <template v-if="max_entress>1">
                     <h2 class="title_step">{{get_local_string.string_91}} {{max_pizza}}</h2>
                </template>
                 <template v-else>
                     <h2 class="title_step">{{get_local_string.string_92}}</h2>
                </template>
                <div class="row">
                   <!-- entress_box -->
                    <template>
                         
                           <div v-for="tilbud_box in get_box_details.entrees" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mb-5"  :key="tilbud_box.id" >
                          <b-checkbox v-model="tilbue_entress_selected" :disabled="tilbue_entress_selected.length >= max_entress && tilbue_entress_selected.indexOf(tilbud_box) == -1" type="is-success"
                            :native-value="tilbud_box" @input="on_select_entrees()">
                             <div class="box_tilbud">
                            <!-- <img :src="tilbud_box.image" :alt="tilbud_box.name"> -->
                           <template v-if="tilbud_box.image">
                                <img :src="tilbud_box.image" :alt="tilbud_box.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>
                            <p>{{tilbud_box.name}}</p>
                        </div>
                        </b-checkbox>
                    </div>
                    </template>
                </div>
            </b-step-item>

            <b-step-item value="3"  label="Done" icon="check-outline" headerClass="final_step"  disabled>
                  <h2 class="title_step">{{get_local_string.string_93}}</h2>
               <div class="final_wrap_tilbud">
                   <div  :class="['row_flex_pizza' ,(showEntress_step)?'':'only_pizza']">
                       <div class="wrap_box_sel" v-for="pizza_sel in tilbue_pizza_selected" :key="pizza_sel.id">
                           <div class="flex_pizza_selected">
                              <!-- <img :src="pizza_sel.image" alt=""> -->
                             
                              <template v-if="pizza_sel.image">
                                <img :src="pizza_sel.image" :alt="pizza_sel.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>

                              <span class="name_sel">{{pizza_sel.name}}</span>
                           </div>
                       </div>
                   </div>
                    <div class="row_flex_entress">
                       <div class="wrap_box_sel" v-for="entress_sel in tilbue_entress_selected" :key="entress_sel.id">
                           <div class="flex_entress_selected">
                              <!-- <img :src="entress_sel.image" alt=""> -->
                             
                                <template v-if="entress_sel.image">
                                <img :src="entress_sel.image" :alt="entress_sel.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>

                              <span class="name_sel">{{entress_sel.name}}</span>
                           </div>
                       </div>
                   </div>
               </div>
            </b-step-item>
            <template #navigation="{previous, next}">
                <div class="step-navigator">
                    <b-button
                    class="mr-3"
                    outlined
                    type="is-danger"
                    icon-pack="fas"
                    icon-left="backward"
                    :disabled="previous.disabled"
                    @click.prevent="previous.action">
                    {{get_local_string.string_89}}
                </b-button>
                <b-button
                    outlined
                    type="is-success"
                    icon-pack="fas"
                    icon-right="forward"
                    :disabled="next_button_disabled"
                    v-if="!submit_form_show"
                    @click.prevent="next.action() , fill_pizza_id() , fill_entrees_id()" >
                     {{get_local_string.string_90}}
                </b-button>
                <template v-if="all_data_cart.status==402">
                     <b-button outlined class="submit_tulbid" :disabled="true" v-if="submit_form_show" :loading="load_multi" type="is-success" native-type="submit"><i class="fas fa-shopping-basket mr-1"  aria-hidden="true"></i>
                      {{get_local_string.string_87}}
                     </b-button>
                </template>
                <template v-else>
                     <b-button outlined class="submit_tulbid" v-if="submit_form_show" :loading="load_multi" type="is-success" native-type="submit"><i class="fas fa-shopping-basket"  aria-hidden="true"></i> 
                     {{get_local_string.string_88}}
                     </b-button>
                </template>
                </div>
            </template>
        </b-steps>
        </form>
    </section>
   </div>
</template>
<script>
import $ from 'jquery';
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
   name:'multiproduct-tilpase',
   data(){
       return{
           labelPosition: 'bottom',
            position: 'left',
            size: 'default',
            tilbue_pizza_selected:[],
            tilbue_entress_selected:[],
            active_step:0,
            submit_form_show:false,
            load_multi:false,
            next_button_disabled:true,
            showEntress_step: true,
            // multi object values
                food_id:null,
                default:0,
                qty:1,
                entrees:null,
                product_multi:[],
                platform:'web',
                max_pizza:null,
                max_entress:1
            // end multi object values
       }
   },
   computed:{
       ...mapGetters({
            get_box_details: 'get_box_details',
            all_data_cart:'all_data_cart',
             get_setting_app:'get_setting_app',
              get_local_string:'get_local_string'
       }),
       ...mapState({
                custom_pizza: 'custom_pizza'
       })
   },
   methods:{
       ...mapActions({
            box_details: 'box_details',
            multi_product_add:'multi_product_add'
            }),
            fetchData_local() {
                // default value from api
                this.food_id = this.custom_pizza.food_id;
                // max user select pizza => get value from api 
                this.max_pizza = this.get_box_details.count_multi;
                 // max user select entress => get value from api 
                //this.max_entress = this.get_box_details.max_entress; => not ready from api #

                // if etrees is empty remove step entress 
                if(this.get_box_details.entrees.length == 0){
                    this.showEntress_step = false;
                    console.log(this.get_box_details.entrees.length , 'entress len');
                }
                
            },
            fill_pizza_id(){
                this.product_multi=[];
                this.tilbue_pizza_selected.forEach(element => {
                    this.product_multi.push(element.id);
                });           
                },
            fill_entrees_id(){
                this.entrees=[];
                this.tilbue_entress_selected.forEach(element => {
                    // this.entrees.push(element.id);
                    this.entrees = element.id;
                });     
            },
            sub(){
                this.load_multi = true;
                let  multi_product_object={}
                if(this.get_box_details.entrees.length == 0)
                {
                     multi_product_object ={
                    'food_id': this.food_id,
                    'default': this.default,
                    'qty':     this.qty,
                    'product_multi':this.product_multi,
                    'platform':this.platform,
                    'lang':localStorage.getItem('Fav_lang'),
                    'entrees':0,
                    }
                }
                else{
                     multi_product_object ={
                    'food_id': this.food_id,
                    'default': this.default,
                    'qty':     this.qty,
                    'product_multi':this.product_multi,
                    'entrees':this.entrees,
                    'platform':this.platform,
                    'lang':localStorage.getItem('Fav_lang')
                        }
                }
                   this.multi_product_add(multi_product_object).then((res)=>{
                        this.load_multi = false;
                       this.$router.go(-1);
                          this.uk.offcanvas($('#offcanvas-flip')).show();
                          $('.list_added_item').find('.move_left').removeClass('modify');
                        console.log('res from mul page' , res);
                })
            },
            get_step_active(){
                if(this.active_step==2){
                    console.log('last step');
                     this.submit_form_show=true;
                      this.scrollup();
                     
                }else{
                    if(this.active_step == 0){
                        // in pizza offers
                        this.on_select_pizza();
                         this.scrollup();
                    }
                    if(this.active_step == 1){
                        // in entress
                        this.on_select_entrees();
                        this.scrollup();
                    }
                    console.log('not last step');
                     this.submit_form_show=false;
                }
            },
            on_select_pizza(){
                // # if user select pizza check box same number from api 
                if(this.tilbue_pizza_selected.length == this.max_pizza){
                    this.next_button_disabled = false;
                }else{
                    this.next_button_disabled = true;
                }
            },
            on_select_entrees(){
                // # if user select etress check box same number from api 
                if(this.tilbue_entress_selected.length == this.max_entress){
                    this.next_button_disabled = false;
                }else{
                    this.next_button_disabled = true;
                }
            },
             go_back(){
                this.$router.go(-1);
            },
            scrollup(){
                 setTimeout(()=>{
                          window.scrollTo(0,0);
                 },300)
            }
            
   },
   mounted(){
     document.documentElement.classList.add('multi_prod');
        // get details this item when pass id to thos func => box_details (id)
        console.log(this.get_box_details.multiFoodList);
        this.box_details(this.$route.params.id).then(()=>{
        this.fetchData_local();
        });
   },
    destroyed(){
     document.documentElement.classList.remove('multi_prod');
    }
}
</script>
<style lang="scss" >
.title_step{
    color: var(--active_color);;
    margin:10px 0px 30px 0px;
    font-size: 25px;
    font-weight: 600;
    border-bottom: 2px solid var(--active_color);
    display: inline-block;
    padding-bottom: 3px;
}
.multi_product_wrap{
.b-checkbox.checkbox input[type=checkbox] + .check {
background-color: var(--main_color);
position: absolute;
top: -6px;
left: 4px;
}
 .control-label , .b-checkbox.checkbox{
        width: 100% !important;
    }
}
</style>
<style lang="scss" scoped>
// .step-content .row{
//    overflow-x: hidden;
// }
.multi_product_wrap{
    padding-top: 40px;
    color: white;
.step-item{
        min-height: 100vh;
    overflow-y: auto;
    padding-top: 20px;
}
.box_tilbud{
    text-align: center;
    border: 1px solid;
    padding: 20px;
    border-radius: 10px;
    color: var(--active_color);
    img{
        width: 130px;
        height: 130px;
        object-fit: contain;
    }
    p{
        margin-top: 15px;
        font-weight: 600;
        font-size: 14px;
    }
}
.final_wrap_tilbud{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.flex_pizza_selected , .flex_entress_selected{
    margin-bottom: 25px;
    text-align: center;
    img{
        width: 160px;
        height: 160px;
        object-fit: contain;
    }
    .name_sel{
        display: block;
        font-size: 15px;
        font-weight: 500;
        margin-top: 8px;
    }
}
}
.flex_entress_selected::before{
    content: "+";
    font-size: 160px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0px);
    color: black;
}
.only_pizza{
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 60px;
}
@media(max-width:767px){
    .multi_product_wrap .box_tilbud {
    padding: 10px 8px;
}
.multi_product_wrap .box_tilbud img{
    width: 100px;
    height: 100px;
}
.multi_product_wrap .box_tilbud p {
    margin-top: 10px;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 5px;
}
// 
.multi_product_wrap .flex_pizza_selected img, .multi_product_wrap .flex_entress_selected img {
    width: 110px;
    height: 110px;
    object-fit: contain;
}
.multi_product_wrap .final_wrap_tilbud {
    justify-content: space-between;
}
.multi_product_wrap .flex_pizza_selected .name_sel, .multi_product_wrap .flex_entress_selected .name_sel{
    display: block;
    font-size: 13px;
    font-weight: 500;
    margin-top: 8px;
    width: 110px;
}
.flex_entress_selected::before {
    content: "+";
    font-size: 100px;
    color: black;
}
}
.step-navigator {
    position: sticky;
    bottom: 0px;
    text-align: center;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: var(--main_color) !important;
    padding: 14px;
}
</style>